"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Mail, Phone, MapPin, Twitter, Linkedin, Github, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <p className="text-sm text-muted-foreground font-sans uppercase tracking-wider">
        Nessun collegamento disponibile.
      </p>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-secondary transition-colors duration-300 font-sans uppercase tracking-widest">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function VistaportFooter() {
  const email = "intelligence@russeo.it";
  const phone = "+39 02 888 999";
  const address = "Milano, IT - Hub Operativo RuNet";
  const socialLinks = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Github,
    href: "#",
    label: "GitHub"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }];
  return <section data-section-id="232659" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/russeo_logo_gold.png" alt="RUSSEO" className="h-7 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed pr-4 font-sans">
              Architetture SEO native per il mercato CSI. Dominanza algoritmica su Yandex e conformità tecnica totale per l'espansione B2B in Russia.
            </p>
            <div className="flex items-center gap-2">
              <div className="size-2 bg-green-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(34,197,94,0.6)]" />
              <span className="text-[10px] font-mono text-green-500 uppercase tracking-widest">Live System Status: Active</span>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 uppercase tracking-widest text-white">
              Navigazione Tecnica
            </h3>
            <MenuProvider menu_id="92">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 uppercase tracking-widest text-white">
              Compliance
            </h3>
            <ul className="space-y-4 text-sm text-muted-foreground font-sans">
              {email && <li className="flex items-start gap-3">
                  <Mail className="size-4 mt-0.5 shrink-0 text-secondary" />
                  <span className="uppercase tracking-wider">{email}</span>
                </li>}
              {phone && <li className="flex items-start gap-3">
                  <Phone className="size-4 mt-0.5 shrink-0 text-secondary" />
                  <span className="uppercase tracking-wider">{phone}</span>
                </li>}
              {address && <li className="flex items-start gap-3">
                  <MapPin className="size-4 mt-0.5 shrink-0 text-secondary" />
                  <span className="uppercase tracking-wider">{address}</span>
                </li>}
              {!email && !phone && !address && <li className="text-sm text-muted-foreground uppercase tracking-wider">
                  Dati di contatto riservati.
                </li>}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 uppercase tracking-widest text-white">
              Social Hub
            </h3>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="text-muted-foreground hover:text-secondary transition-all duration-300 hover:scale-110">
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <Separator className="my-10 bg-white/5" />
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[11px] text-muted-foreground font-mono uppercase tracking-widest">
          <p>
            © {new Date().getFullYear()} RUSSEO INTELLIGENCE. Tutti i diritti riservati.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors duration-300 text-primary font-bold">
              Back to Top
            </Link>
            <Link to="#" className="hover:text-secondary transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-secondary transition-colors duration-300">
              FZ-152 Compliance
            </Link>
          </div>
        </div>
      </div>
    </section>;
}